import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsdotTrafficFlowApiMeta } from "../apiMeta";
import {
  type TrafficFlowByIdInput,
  trafficFlowByIdInputSchema,
} from "./shared/flowData.input";
import { type FlowData, flowDataSchema } from "./shared/flowData.output";

/**
 * Metadata for the fetchTrafficFlowById endpoint
 */
export const trafficFlowByIdMeta = {
  functionName: "fetchTrafficFlowById",
  endpoint: "/getTrafficFlowAsJson?FlowDataID={FlowDataID}",
  inputSchema: trafficFlowByIdInputSchema,
  outputSchema: flowDataSchema,
  sampleParams: { FlowDataID: 2482 },
  endpointDescription:
    "Get current traffic flow condition for a specific station by ID.",
} satisfies EndpointMeta<TrafficFlowByIdInput, FlowData>;

/**
 * Fetch function for retrieving current traffic flow condition for a specific station by ID
 */
const { fetch, useHook } = createFetchAndHook<
  TrafficFlowByIdInput,
  FlowData
>({
  api: wsdotTrafficFlowApiMeta,
  endpoint: trafficFlowByIdMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/flowData.endpoints").flowDataGroup.cacheStrategy,
});

/**
 * Fetch function for retrieving current traffic flow condition for a specific station by ID
 */
export const fetchTrafficFlowById: FetchFactory<
  TrafficFlowByIdInput,
  FlowData
> = fetch;

/**
 * React Query hook for retrieving current traffic flow condition for a specific station by ID
 */
export const useTrafficFlowById: HookFactory<TrafficFlowByIdInput, FlowData> =
  useHook;
